import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  pingRequestBusy$,
  requestFallbackPreloaderMessage$,
} from '../../../common/utils/pingRequest';
import { HostMessageService } from '../../../services/host-message.service';
import { PreloaderService } from '../../../services/preloader.service';
import * as Utility from '../../../shared/helpers/utility';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.2s ease-in-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.2s ease-in-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class PreloaderComponent implements OnDestroy {
  public Utility = Utility;
  public isBusy: boolean = true;
  public pingRequestBusy = false;
  public requestFallbackMessage: string | null = null;
  private appBusy = true;
  private destroy$ = new Subject<void>();
  constructor(
    public service: PreloaderService,
    private hostMessageService: HostMessageService,
  ) {
    this.service.isBusy.pipe(takeUntil(this.destroy$)).subscribe((isBusy) => {
      this.appBusy = isBusy;
      this.updateBusyState();
    });

    pingRequestBusy$.pipe(takeUntil(this.destroy$)).subscribe((isBusy) => {
      this.pingRequestBusy = isBusy;
      this.updateBusyState();
    });

    requestFallbackPreloaderMessage$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => {
        this.requestFallbackMessage = message;
        this.updateBusyState();
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateBusyState(): void {
    const nextIsBusy =
      this.appBusy || this.pingRequestBusy || !!this.requestFallbackMessage;
    const wasBusy = this.isBusy;
    this.isBusy = nextIsBusy;
    if (wasBusy && !nextIsBusy) {
      this.hostMessageService.postMessage({ type: 'widget-ready' });
    }
  }
}
